/* Quick filter chips in the collection hero.
 *
 * THERE IS ONE FILTERING PATH AND THIS IS NOT IT. A chip does not fetch
 * anything, does not build a URL and does not know what a filter is. It finds
 * the drawer's own checkbox for its value, toggles it, and submits the filter
 * form -- so a chip click and a checkbox tick are the same action, executed by
 * the same handler. They cannot disagree, because there is nothing to disagree
 * with.
 *
 * WHY ANY SCRIPT IS NEEDED AT ALL. Filtering re-renders #facets-filterable,
 * which lives in the product grid section. The hero is a different section and
 * is never re-rendered, so chips drawn on page load would keep their original
 * active and sold-out states forever. After each render this reads those
 * states back off the freshly rendered checkboxes. The server remains the
 * source of truth; this only relays it to a part of the page the server did
 * not redraw.
 *
 * The URL is still the state, written by the theme's own handler. Back and
 * forward work because of that, and are picked up here through popstate.
 */
(function () {
  var FORM = '#Facet-Filters-Form';
  var GRID = 'facets-results';
  var REGION = 'facets-filterable';

  function chips() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-occasion-chip]'));
  }

  function form() {
    return document.querySelector(FORM);
  }

  /* The drawer renders a mobile and a desktop copy of each control, so every
     matching input is toggled -- leaving one behind would send a FormData that
     disagrees with what the customer just pressed. */
  function inputsFor(param, value) {
    var scope = form();
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('input[type="checkbox"]')).filter(
      function (input) {
        return input.name === param && input.value === value;
      }
    );
  }

  /* The URL is the state, and it is readable before anything has been
     teleported or re-rendered. Used as the fallback whenever the drawer's
     checkbox for a value cannot be found. */
  function activeFromUrl() {
    var out = {};
    window.location.search
      .replace(/^\?/, '')
      .split('&')
      .forEach(function (pair) {
        if (!pair) return;
        var i = pair.indexOf('=');
        if (i < 0) return;
        var key = decodeURIComponent(pair.slice(0, i).replace(/\+/g, ' '));
        var val = decodeURIComponent(pair.slice(i + 1).replace(/\+/g, ' '));
        (out[key] = out[key] || []).push(val);
      });
    return out;
  }

  function syncFromDrawer() {
    var fromUrl = activeFromUrl();
    chips().forEach(function (chip) {
      var input = inputsFor(chip.dataset.param, chip.dataset.value)[0];

      /* Checkbox first, because only the server knows the counts. URL second,
         because the drawer lives inside a <template> until Alpine teleports it
         and is simply not in the document before that. */
      var on = input
        ? input.checked
        : (fromUrl[chip.dataset.param] || []).indexOf(chip.dataset.value) !== -1;

      chip.setAttribute('aria-pressed', on ? 'true' : 'false');

      /* Struck through rather than hidden: a row that changes length on every
         click moves the next chip out from under the finger about to press it.
         Only knowable from the checkbox, so a chip stays clickable until one
         is found rather than being disabled on a guess. */
      var empty = !!input && input.disabled && !input.checked;
      if (empty) chip.setAttribute('data-empty', 'true');
      else chip.removeAttribute('data-empty');
      chip.disabled = empty;
      chip.removeAttribute('data-pending');
    });
  }

  /* scrollIntoView is deliberately not used: it fights the sticky header and
     parks the first row of products underneath it. */
  function revealGrid() {
    var grid = document.getElementById(GRID);
    if (!grid) return;
    var header = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );
    var offset = (isFinite(header) ? header : 80) + 16;
    var top = grid.getBoundingClientRect().top + window.pageYOffset - offset;
    if (top < window.pageYOffset) window.scrollTo({ top: top > 0 ? top : 0, behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-occasion-chip]');
    if (!chip || chip.disabled) return;
    e.preventDefault();

    var inputs = inputsFor(chip.dataset.param, chip.dataset.value);
    var target = form();

    /* The drawer sits in a <template> until Alpine teleports it, so on a very
       early click there is no checkbox to toggle yet. Rather than be a dead
       control, the chip falls back to navigating to the same filtered URL the
       form would have produced -- a page load instead of a swap, but never
       nothing. */
    if (!inputs.length || !target) {
      var params = new URLSearchParams(window.location.search);
      var existing = params.getAll(chip.dataset.param);
      params.delete(chip.dataset.param);
      var wanted = existing.indexOf(chip.dataset.value) === -1;
      existing.forEach(function (v) {
        if (v !== chip.dataset.value) params.append(chip.dataset.param, v);
      });
      if (wanted) params.append(chip.dataset.param, chip.dataset.value);
      var query = params.toString();
      window.location.href = window.location.pathname + (query ? '?' + query : '');
      return;
    }

    var next = !inputs[0].checked;
    inputs.forEach(function (input) {
      input.checked = next;
    });

    /* Optimistic only as far as this chip. Everything else waits for the
       server, because only the server knows what the other counts become. */
    chip.setAttribute('aria-pressed', next ? 'true' : 'false');
    chip.setAttribute('data-pending', 'true');

    /* requestSubmit fires a real submit event, which is what the theme's own
       @submit.prevent="filterFormSubmit" is listening for. Calling submit()
       would bypass it and reload the page. */
    if (typeof target.requestSubmit === 'function') target.requestSubmit();
    else target.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

    resyncSoon();
    if (next) revealGrid();
  });

  /* WATCHING #facets-filterable IS NOT ENOUGH, and this was the bug. The whole
     filter drawer is wrapped in <template data-should-teleport>, so Alpine
     moves it OUT of that region into the drawer slot -- an observer on the
     region never saw the checkboxes change, and the chips never lit up even
     though the filter had applied.

     The document is watched instead, debounced, with a callback cheap enough
     that the breadth costs nothing. */
  function watch() {
    var pending = null;
    new MutationObserver(function () {
      if (pending) window.clearTimeout(pending);
      pending = window.setTimeout(syncFromDrawer, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* The theme waits 300ms before swapping the markup in, and teleporting
     happens a tick after that. These catch the result even if no mutation the
     observer can see happens to fire. */
  function resyncSoon() {
    [350, 700, 1200].forEach(function (ms) {
      window.setTimeout(syncFromDrawer, ms);
    });
  }

  window.addEventListener('popstate', function () {
    /* The theme re-renders on popstate too; this runs after that lands. */
    window.setTimeout(syncFromDrawer, 350);
  });

  function start() {
    syncFromDrawer();
    watch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
